import { render, staticRenderFns } from "./VirtualPackingSlipShipmentDetails.vue?vue&type=template&id=6a24dffd&scoped=true&"
import script from "./VirtualPackingSlipShipmentDetails.vue?vue&type=script&lang=js&"
export * from "./VirtualPackingSlipShipmentDetails.vue?vue&type=script&lang=js&"
import style0 from "./VirtualPackingSlipShipmentDetails.vue?vue&type=style&index=0&id=6a24dffd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a24dffd",
  null
  
)

export default component.exports